module.exports = __webpack_public_path__ + "static/media/merge-white.ecd87316.png";